# - contents:
#     - name:
#         en: IEEE, IPSJ, JSAI; Student Member
#         ja: IEEE, 情報処理学会, 人工知能学会; それぞれ学生会員
#   title:
#     en: Membership
#     ja: 会員
- title:
    ja: 企画運営
    en: Organiser
  contents:
    - name: |
        "Tutorials on Scalable Multi-Robot Planning: From MAPF Algorithms to Real Robotic Systems" at IROS, 2026. w/Jiaoyang Li, Yulun Zhang, Jingkai Chen, Han Zhang, and Sven Koenig
      url: https://sites.google.com/view/iros-26-mapf-tutorial/home
    - name:
        en: |
          Organised session "Search and Planning" at JSAI, 2026. w/Ryo Kuroiwa
        ja: |
          JSAI2026 オーガナイズドセッション「探索とプランニングの基礎と応用」 w/Ryo Kuroiwa
      url: https://www.ai-gakkai.or.jp/jsai2026/os/
      #
    - name: The 6th International Workshop on Multi-Agent Path Finding at AAAI, 2025. w/Zhe Chen, Jingkai Chen, Rishi Veerapaneni, Yue Zhang
      url: https://womapf.github.io/aaai-25/
    - name:
        en: |
          Multi-agent and multi-robot planning workshop in Tokyo, 2024. w/Keisuke Otaki
        ja: |
          マルチエージェント・マルチロボットプランニング研究会 2024. w/Keisuke Otaki
      url: https://sites.google.com/view/multi-agent-robot-planning-24
- title:
    ja: Area Chair
    en: Area Chair
  contents:
    - name: |
        2025: MRS
- contents:
    - name: |
        2027: AAAI (PC)
    - name: |
        2026: AAAI (PC), ICRA, AAMAS (PC), ICAPS (PC), RA-L, IJCAI (PC), AIJ, NeurIPS, CoRL, T-RO, IJRR
    - name: |
        2025: AAAI (PC), ICRA, AIJ, RA-L, IJCAI (PC), JAAMAS, RSS, T-RO, JAIR
    - name: |
        2024: ICRA, AAAI (PC), RA-L, IJCAI (PC), T-IV, Robotics and Autonomous Systems, RSS, JSAI, TPDS, JAIR, CP, AIJ, CoRL, IJRR
    - name: |
        2023: ICRA, AAAI (PC), WoMAPF (PC), JAAMAS, IJCAI (PC), T-RO, RSS, RA-L, T-ITS, TMECH, CASE, ESA, TCDS, MRS, Robotics and Autonomous Systems, JAIR, T-IV, TPDS
    - name: |
        2022: RA-L, ICRA, IROS, TCDS, T-ASE, JETAI
    - name: |
        2021: ICDCN, RA-L, ICRA, IROS
  title:
    en: Reviewer / Program Committee
    ja: 査読
# - contents:
#     - name:
#         en: Computer Literacy 2a(IL1), 2021
#         ja: コンピュータ・リテラシ 2a(IL1), 2021
#   title:
#     en: Teaching Assistant
#     ja: ティーチング・アシスタント
- contents:
    - name: Kei18's Note
      url: https://kei18.github.io/note
    - name: researchmap
      url:
        en: https://researchmap.jp/Kei18?lang=en
        ja: https://researchmap.jp/Kei18
    - name: YouTube
      url: https://www.youtube.com/@keisuke_okumura
    - name: Speaker Deck
      url: https://speakerdeck.com/kei18
  title:
    en: Links, Materials, Slides
    ja: リンク・資料・スライド
- contents:
    - name: IEEE Spectrum Video Friday (2026)
      url: https://spectrum.ieee.org/roadrunner-bipedal-robot#41kpw6jwxty
    - name:
        en: Fantástico (Oct. 2025)
        ja: Fantástico (2025年10月)
      url: https://g1.globo.com/fantastico/video/mentes-digitais-professora-brasileira-lidera-pesquisas-de-inteligencia-coletiva-no-reino-unido-14044982.ghtml
    - name:
        en: BBC Click (Mar. 2025)
        ja: BBC Click (2025年3月)
      url: https://www.bbc.co.uk/iplayer/episode/m0029673/click-15032025
    - name:
        ja: オムロン・ニュースルーム (2022年4月)
        en: OMRON News
      url: https://www.omron.com/jp/ja/news/2022/04/c0427.html
    - name: あなたのあるく一歩さき someone vol.51 (2020年6月)
      url: https://lne.st/business/publishing/someone/
  title:
    en: Media
    ja: メディア
# - contents:
#     - name:
#         en: 社会の進化に繋がる「研究」とは? ～研究をイノベーションに繋げ、どう社会還元していくかを考える～ (Nov. 2017)
#         ja: 社会の進化に繋がる「研究」とは? ～研究をイノベーションに繋げ、どう社会還元していくかを考える～ (2017年11月)
#       url: https://makers-u.jp/people/makersfile/blog/post-3236
#     - name:
#         en: 東工大 Off the Rails vol.2 NEW学式 出展 (Apr. 2017)
#         ja: 東工大 Off the Rails vol.2 NEW学式 出展 (2017年4月)
#     - name:
#         en: Tokyo Tech wins big at Japan’s largest student hackathon (Jan. 2017)
#         ja: 東工大メディア研究会が2つの日本最大級のソフトウェア開発イベントで最優秀賞を受賞 (2017年1月)
#       url:
#         en: https://www.titech.ac.jp/english/news/2017/036942.html
#         ja: https://www.titech.ac.jp/news/2017/036940.html
#     - name:
#         en: STUDENT INTERVIEW - MAKERS UNIVERSITY (Oct. 2016)
#         ja: STUDENT INTERVIEW - MAKERS UNIVERSITY (2016年10月)
#       url: https://makers-u.jp/people/makers01/keisuke-okumura
#     - name:
#         en: Web技術入門~ASP.netの基礎とWebアプリ作成方法~ (Jun. 2016)
#         ja: Web技術入門~ASP.netの基礎とWebアプリ作成方法~ (2016年6月)
#       url: https://jazug-student.doorkeeper.jp/events/44795
#     - name:
#         en: Maker Faire Tokyo 2015 出展 (Aug. 2015)
#         ja: Maker Faire Tokyo 2015 出展 (2015年8月)
#       url: https://makezine.jp/event/mft2015/
#   title:
#     en: Talks / Exhibitions / Meadia (≠ Research Activities)
#     ja: 登壇・展示・記事 (研究外)
# - contents:
#     - name:
#         en: MAKERS UNIVERSITY, Maru-zemi
#         ja: MAKERS UNIVERSITY, 丸ゼミ
#       url: https://makers-u.jp/
#     - name: TECH LAB PAAK, Community Member
#       url: http://techlabpaak.com/
#     - name:
#         en: Leave a Nest, Internship
#         ja: 株式会社リバネス・インターンシップ
#       url: https://lne.st/recruit/intern/
#     - name: Microsoft Student Partner
#       url:
#         en: https://studentambassadors.microsoft.com
#         ja: https://studentambassadors.microsoft.com/ja-JP
#     - name:
#         en: FREE-QUENCY, Internship
#         ja: 有限会社フリークエンシー・インターンシップ
#       url: https://www.free-quency.com/
#     - name:
#         en: Life is Tech ! Student Mentor
#         ja: Life is Tech ! メンター
#       url: https://life-is-tech.com/
#   title:
#     en: Past Community / Internship
#     ja: 過去のコミュニティやインターンなど
# - contents:
#     - name: |
#         handy : C++ / Python / Julia / Web-Front
#     - name: |
#         working experience : Scala / JavaScript / TypeScript / Unity / PHP / Java
#           / R / vvvv
#     - name: |
#         studying or wanna : Common Lisp, Elixer
#   title:
#     en: Skill
#     ja: スキル
# - name:
#     en: Medium (others)
#     ja: Medium (その他)
#   url: https://medium.com/@Kei18
# title:
#   en: Blog (mostly in Japanese)
#   ja: ブログ
